import React, { Fragment } from 'react'

import { useTable, useSortBy, usePagination, useGlobalFilter } from "react-table";

import { Table as BTable } from "react-bootstrap" ;

import './PassportTable.scss' ;

export const max = ( a, b ) =>
{
    if ( +a > +b )
    {
        return  (+a) ;
    }
    else
    {
        return ( +b) ;
    }
}

export const min = ( a, b ) =>
{
    if ( +a < +b )
    {
        return  (+a) ;
    }
    else
    {
        return ( +b) ;
    }
}

export const pcentFormatter = ( cell ) =>
{
    return cell + "%" ;
}

export const stripFloat = (number) =>
{
    if ( number === 100 || number === -100 )
    {
        return number;
    }
    else
    {
        return (parseFloat(number).toPrecision(2));
    }
}

// Route a cell formatter to the original react-bootstrap-table cell renderer
function formatWrapper( { value, row, column }  )
{
    if ( column.formatter !== undefined )
    {
        return column.formatter ( value, row.original ) ;
    }
    else
    {
        if ( value !== undefined )
        {
            return value ;
        }
        else
        {
            return '' ;
        }
    }
}

// This function maps a react-bootstrap-table column definition to a react-table header definition, including:
// formatter:
export const xlateBootstrapTableColumns = (columns) =>
{
    const translations = columns.map((col) =>
    {
        let rval = {
            Header: col.text,
            accessor: col.dataField,
            Cell: formatWrapper
        }

        if ( col.formatter !== undefined )
        {
            rval.formatter = col.formatter ;
        }

        if ( col.sort === undefined || col.sort === false )
        {
            rval.disableSortBy = true ;
        }
        else
        {
            rval.disableSortBy = false ;
        }

        if ( col.width !== undefined )
        {
            rval.width = col.width;
        }

        if ( col.align !== undefined )
        {
            rval.align = col.align;
        }

        if ( col.headerStyle !== undefined )
        {
            rval.headerStyle = col.headerStyle;
        }

        if ( col.sortType !== undefined )
        {
            rval.sortType = col.sortType ;
        }

        return rval ;
    })

    return translations ;
}

const PassportTable = ({ columns, data, pagination, showSearch, tableClass }) =>
{
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        setGlobalFilter,
        rows,
        page, // Instead of using 'rows', we'll use page,
        // which has only the rows for the active page

        // The rest of these things are super handy, too ;)
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize, globalFilter },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    )

    const tablePaginator = () =>
    {
        {/*
        Pagination can be built however you'd like.
        This is just a very basic UI implementation:
      */}

        if ( pagination.hidePageListOnlyOnePage && !canNextPage && !canPreviousPage )
        {
            return <div />
        }
        else
        {
            return (
                <div className="table-pagination">
                    <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        {'>>'}
                    </button>{' '}
                    <button onClick={() => nextPage()} disabled={!canNextPage}>
                        {'>'}
                    </button>{' '}
                    <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                        {'<'}
                    </button>{' '}
                    <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        {'<<'}
                    </button>{' '}
                    <span>
          Page{' '}
                        <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
                    <span>
          | Go to page:{' '}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0
                                gotoPage(page)
                            }}
                            style={{ width: '100px' }}
                        />
        </span>{' '}
                    <select
                        value={pageSize}
                        onChange={e => {
                            setPageSize(Number(e.target.value))
                        }}
                    >
                        {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                </div>
            )

        }
    }

    const renderNormalHeaderGroup = ( headerGroup ) =>
    {
        return (
            <tr className='clipped-row-class' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => {

                    const s1 = column.headerStyle !== undefined ? column.headerStyle ( { dataField: column.id  }) : {};

                    const style = { ...s1, ...column.canSort ? { cursor: 'pointer'} : { cursor: 'default' }} ;

                    return (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())} style={style} >
                            {column.render('Header')}
                            <span>
                                {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                            </span>
                        </th>
                    ) } )}
            </tr>
        )
    }

    const renderChildHeaderGroup = ( headerGroup ) =>
    {
        return (
            <tr className='clipped-row-class' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => {

                    const s1 = column.headerStyle !== undefined ? column.headerStyle ( { dataField: column.id  }) : {};

                    const style = { ...s1, ...column.canSort ? { cursor: 'pointer'} : { cursor: 'default' }} ;

                    return (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())} style={style} >
                            {column.render('Header')}
                            <span>
                                {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                            </span>
                        </th>
                    ) } )}
            </tr>
        )
    }

    const headerRenderer = tableClass === 'passport-table' ? renderNormalHeaderGroup : renderChildHeaderGroup ;

    // Render the UI for your table
    return (
        <div className={tableClass}>
            { showSearch === true && <div className='table-search'>
                <input
                    type="text"
                    value={globalFilter || ""}
                    placeholder={'Search...'}
                    onChange={e => setGlobalFilter(e.target.value)}
                />
            </div> }
            <BTable striped bordered hover size="sm"  {...getTableProps()}>
                <thead>
                {headerGroups.map(headerGroup => headerRenderer(headerGroup))}
                </thead>
                <tbody {...getTableBodyProps()}>
                {page.map((row, i) => {
                    prepareRow(row)
                    return (
                        <tr className='clipped-row-class' {...row.getRowProps()}>
                            {row.cells.map(cell => {

                                let style = {} ;

                                if ( cell.column.align !== undefined )
                                {
                                    style = { textAlign: cell.column.align };
                                }

                                return <td {...cell.getCellProps()} style={style}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
                </tbody>
            </BTable>

            { tablePaginator() }
        </div>
    )
}

PassportTable.defaultProps =
{
    showSearch: true,
    tableClass: 'passport-table'
}

export default PassportTable ;
